import { CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid";
import { GridItem } from "../../components/GridItem";

export default function TerritoriesList({
  btns,
  headerInfo,
  territories,
  openMap,
  setHeaderInfo,
}) {
  return (
    <div
      style={{
        backgroundColor: "#eaeaea",
        flex: btns && (!headerInfo.ter || headerInfo.ter === "waiting") ? 1 : 0,
        overflow: "hidden",
        alignContent: headerInfo.ter === "waiting" ? "center" : "start",
        textAlign: "center",
      }}
    >
      {headerInfo.ter === "waiting" ? (
        <CircularProgress size={24} />
      ) : (
        !headerInfo.ter && (
          <Grid
            container
            spacing={5}
            padding={2}
            columns={{ xs: 1, sm: 8, md: 20 }}
          >
            {territories.map((o, index) => {
              return (
                <Grid id={o.id} item xs={1} sm={4} md={4} key={index}>
                  <GridItem
                    id={o.id}
                    style={{
                      textAlign: "left",
                      position: "relative",
                      cursor: "pointer",
                      height: "100%",
                    }}
                  >
                    <div
                      key={index}
                      onClick={() => {
                        openMap({ id: o.TER, name: o.NOM });
                        setHeaderInfo({
                          ...headerInfo,
                          ter: "waiting",
                        });
                      }}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        fontSize: 20,
                        alignItems: "center",
                        marginRight: 10,
                      }}
                    >
                      {o.NOM}
                    </div>
                  </GridItem>
                </Grid>
              );
            })}
          </Grid>
        )
      )}
    </div>
  );
}
